import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, CircularProgress, Alert
} from '@mui/material';
import { useAuth } from "../../context/AuthContext";

const TaxonomyDialog = ({ open, onClose, title, endpoint, items, setItems, fieldName = 'name' }) => {
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { authToken } = useAuth();

    const handleSave = async () => {
        if (!value.trim()) return;
        setLoading(true);
        setError(null);
        try {
            const payload = { [fieldName]: value };
            const res = await fetch(`${import.meta.env.VITE_API_URL}/${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                body: JSON.stringify(payload)
            });

            if (res.ok) {
                const newItem = await res.json();
                setItems([...items, newItem]);
                setValue('');
                onClose();
            } else {
                const errData = await res.json();
                setError(errData.message || 'Error al crear');
            }
        } catch (e) {
            console.error(e);
            setError('Error de conexión');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '20px', p: 1 } }}>
            <DialogTitle sx={{ fontWeight: 800 }}>{title}</DialogTitle>
            <DialogContent>
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                <TextField
                    autoFocus
                    margin="dense"
                    label="Nombre"
                    fullWidth
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    variant="outlined"
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                />
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} color="inherit" sx={{ borderRadius: '10px' }}>Cancelar</Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    disabled={loading || !value.trim()}
                    sx={{ borderRadius: '10px', boxShadow: 'none' }}
                >
                    {loading ? <CircularProgress size={24} /> : 'Crear'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TaxonomyDialog;
